import React from 'react';
import styles from './GenericModal.module.scss';

export class GenericModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: this.props.open
        }
    }

    close = () => {
        this.setState({
            open: false
        })
        if(this.props.handleClose) this.props.handleClose();
    }
    render() {
        const {
            title,
            content,
        } = this.props;
        return (
            <div className={styles["generic-modal-container"]}>
                {this.state.open && 
                    <div className={styles["wrapper"]}>
                        <div className={styles["overlay"]} onClick={this.close} data-automation-id="mmodal-overlay"></div>
                        <div className={styles["modal-container"]}>
                            {title && <h1 className={styles["title"]}> {title} </h1>}
                            {content}
                        </div>
                    </div>
                }
            </div>
        )
    }

}


GenericModal.propTypes = {
    
};

export default GenericModal;